import { Link } from "react-router-dom";
import { SheetClose } from "../common/sheet";

export const MobileNavButton = ({ route, label, Icon, handleClose }) => {
  return (
    <>
      {label.toLowerCase() === "my nutrients" ? (
        <a
          href={route}
          className={`${
            window.location.pathname === route
              ? "text-white bg-[#274760] rounded-xl px-2 py-1"
              : "rounded-xl px-2 py-1"
          }`}
        >
          <p
            className={`flex items-center gap-2 mb-0 ${
              window.location.pathname === route
                ? "text-white bg-[#274760] font-normal"
                : "font-normal"
            }`}
          >
            {Icon}
            <span className="text-[14px]">{label}</span>
          </p>
        </a>
      ) : (
        <Link
          to={route}
          className={`${
            window.location.pathname === route
              ? "text-white bg-[#274760] rounded-xl px-2 py-1"
              : "rounded-xl px-2 py-1"
          }`}
        >
          <SheetClose>
            <p
              className={`flex items-center gap-2 mb-0 ${
                window.location.pathname === route
                  ? "text-white bg-[#274760] font-normal"
                  : "font-normal"
              }`}
            >
              {Icon}
              <span className="text-[14px]">{label}</span>
            </p>
          </SheetClose>
        </Link>
      )}
    </>
  );
};
